<template>

    <section class="checkout-section calculate-postage">
        <h1><span>2. </span>Calculate postage</h1>
        <label for="shipping-destination">Where should we ship your order to?</label>
        <select :disabled="digital_delivery" name="shipping-destination" id="shipping-destination" @change="$emit('updated', $event.target.value)">
            <option v-for="(country, code) in countries" :value="code" :selected="code === selected">{{ country }}</option>
        </select>
        <p v-if="digital_delivery" class="ta-r mt050 fz100">Digital delivery: <b v-text="total ? $filters.getCurrencyValue(total) : 'Free'"></b></p>
        <p v-else class="ta-r mt050 fz100">Shipping ({{ zone }}): <b v-text="total ? $filters.getCurrencyValue(total) : 'Free'"></b></p>
        <p class="ta-r mt025" v-if="discount">(Multi item discount applied)</p>
    </section>

</template>

<script>

export default {

	data(){
		return {

        }
    },
    props: [
    	'countries',
        'selected',
        'zone',
        'total',
        'discount',
        'instructions',
        'digital_delivery'
    ],
    computed:
    {
	    local_instructions: {
	    	get(){ return this.instructions },
            set(val){ this.$emit('update:instructions', val) }
        }
    }
}

</script>
